module.exports = __webpack_public_path__ + "img/1970East-001_WEB-min.07960e41.jpg";